import {
  callApiLayTatCaApp,
  callApiLayDanhSachAppPaging,
  callApiThemMoiApp,
  callApiCapNhatApp,
  callApiXoaApp,
  callApiCapNhatThuTu,
  callApiCapNhatTrangThaiApp,
  callApiGetListApp,
} from "@/api/app";
import {
  XOA_APP_THANH_CONG
} from "@/constants/message";
import { showMsgOk, showMsgError } from "@/utils/commonUtils";

const layTatCaApp = async ({ commit }, payload) => {
  const response = await callApiLayTatCaApp(payload);
  if (response && response.data.succeeded) {
    commit("LAY_TAT_CA_APP_THANH_CONG", response.data.data);
    if (payload && payload.onSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.data);
    }
  }
};

const getListApp = async ({ commit }, payload) => {
  const response = await callApiGetListApp(payload);
  if (response && response.data.succeeded) {
    commit("LAT_LIST_APP_THANH_CONG", response.data.data);
    if (payload && payload.onSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.data);
    }
  }
};

const layDanhSachAppPaging = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachAppPaging(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_APP_PAGING_THANH_CONG", response.data.data);
  }
};


// eslint-disable-next-line no-empty-pattern
const themMoiApp = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiApp(payload.data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
};

// eslint-disable-next-line no-empty-pattern
const capNhatApp = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatApp(payload.data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
};

// eslint-disable-next-line no-empty-pattern
const xoaApp = async (context, payload) => {
  const response = await callApiXoaApp(payload.data);
  if (response && response.data.succeeded) {
    showMsgOk(XOA_APP_THANH_CONG);
    payload.onSuccess();
  }
};

const capNhatThuTu = async (context, payload) => {
  const response = await callApiCapNhatThuTu(payload.data);
  if (response && response.data.succeeded) {
    payload.onSuccess();
  }
};

// eslint-disable-next-line no-empty-pattern
const capNhatActiveApp = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatTrangThaiApp(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

export default {
  layTatCaApp,
  layDanhSachAppPaging,
  themMoiApp,
  capNhatApp,
  xoaApp,
  capNhatThuTu,
  capNhatActiveApp,
  getListApp
};
